import { InmateSubscriptionFilters } from '@reliance/types/filters/InmateSubscriptionFilters';
import { InmateSubscription } from '@reliance/types/models/InmateSubscription';
import { useAsync } from 'react-async-hook';
import api from '../common/api';
import { IPaginatedResponse } from '../common/reliance-api-service';

export const useInmateSubscriptions = (filters?: InmateSubscriptionFilters) => {
  return useAsync<IPaginatedResponse<InmateSubscription>>(
    () => filters ? api.get<IPaginatedResponse<InmateSubscription>>('/inmate-subscription', { params: filters }).then(r => r.data) : null,
    [filters]
  );
};

export const useInmateSubscriptionsByInmateId = (
  inmateId: number | null | undefined
) => {
  return useAsync<IPaginatedResponse<InmateSubscription>>(
    (currentInmateId?: number | null | undefined) => {
      const id = currentInmateId !== undefined ? currentInmateId : inmateId;
      if (!id) {
        return null;
      }

      const params = {
        inmateId: id,
      };

      return api
        .get<IPaginatedResponse<InmateSubscription>>('/inmate-subscription', { params })
        .then((r) => r.data);
    },
    // Use empty array when inmateId is null to prevent auto-execution (for manual control)
    inmateId === null ? [] : [inmateId]
  );
};
